<template>
  <flex-column class="wrapper">
    <flex-body>
      <div class="padder">
        <h5>{{ options.title }}</h5>
        <div v-html="options.description" />
      </div>
    </flex-body>
    <flex-footer>
      <div class="padder">
        <flex-row>
          <flex-cell>
            <ux-button color="dismiss" @click="dismiss">{{
              cancelText
            }}</ux-button>
          </flex-cell>

          <flex-cell>
            <ux-button color="primary" @click="close">{{
              confirmText
            }}</ux-button>
          </flex-cell>
        </flex-row>
      </div>
    </flex-footer>
  </flex-column>
</template>
<script>
import ModalMixin from "./ModalMixin";

export default {
  mixins: [ModalMixin],
  computed: {
    confirmText() {
      return this.options.confirmText || "Confirm";
    },
    cancelText() {
      return this.options.cancelText || "Cancel";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleKeyDown(event) {
      switch (event.key) {
        case "Enter":
          this.close();
          break;
        case "Escape":
          this.dismiss();
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  border-radius: 0.5em;
  overflow: hidden;
  background: var(--bg1, #fff);
  text-align: center;
  max-width: 400px;
  padding: 1.5em;

  h5 {
    font-size: 1.2em;
    margin: 0 0 0.5em;
  }

  .padder {
    margin-bottom: 2em;
  }
}
</style>
